(() => {
  if (window.__yurchakExpressBootstrapped) return;
  window.__yurchakExpressBootstrapped = true;

  const VARIANT_ID = Number(window.YurchakCartCore?.expressVariantId || 0);
  const HANDLE = window.YurchakCartCore?.expressHandle || 'express-delivery-upgrade';
  if (!VARIANT_ID) {
    console.warn('[YURCHAK Express] Service variant is unavailable; Express controls are disabled.');
    return;
  }
  const routeRoot = () => window.Shopify?.routes?.root || '/';
  let busy = false;
  let normalizeTimer = 0;

  const roots = () => Array.from(document.querySelectorAll('[data-yurchak-express]'));
  const serviceItems = cart => Array.isArray(cart?.items)
    ? cart.items.filter(item => Number(item?.variant_id) === VARIANT_ID || item?.handle === HANDLE)
    : [];

  const cartCore = window.YurchakCartCore;
  const fetchCart = () => cartCore?.fetchCart ? cartCore.fetchCart() : fetch(routeRoot() + 'cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}}).then(r=>r.json());

  const updateAttributes = selected =>
    cartCore?.updateCart
      ? cartCore.updateCart({
          attributes: {
            'Express dispatch': selected
              ? 'Selected (+$8) · eligible 5–7 business day items → 3–4 business days'
              : ''
          }
        })
      : Promise.reject(new Error('Cart core unavailable.'));

  const expressAttribute = selected => ({
    'Express dispatch': selected ? 'Selected (+$8) · eligible 5–7 business day items → 3–4 business days' : ''
  });

  const addService = async currentCart => {
    const current = currentCart || await fetchCart();
    const existing = serviceItems(current);
    if (existing.length) {
      const updates = {};
      existing.forEach((item,index) => {
        const quantity = index === 0 ? 1 : 0;
        if (Number(item.quantity) !== quantity) updates[item.key] = quantity;
      });
      if (Object.keys(updates).length) return cartCore.updateLines(updates, expressAttribute(true));
      return updateAttributes(true);
    }
    if (!cartCore?.addItems) throw new Error('Cart core unavailable.');
    await cartCore.addItems([{
      id: VARIANT_ID,
      quantity: 1,
      properties: {
        'Express dispatch': '3–4 business days (+$8)',
        '_yurchak_express_delivery': 'true'
      }
    }]);
    return updateAttributes(true);
  };

  const removeService = async currentCart => {
    const cart = currentCart || await fetchCart();
    const updates = {};
    serviceItems(cart).forEach(item => { updates[item.key] = 0; });
    return cartCore.updateLines(updates, expressAttribute(false));
  };

  const setBusy = (state, source) => {
    roots().forEach(root => {
      root.classList.toggle('is-busy', state);
      root.querySelectorAll('[data-yurchak-express-toggle]').forEach(input => {
        input.disabled = state || root.dataset.eligible !== 'true';
      });
      const status = root.querySelector('[data-yurchak-express-status]');
      if (status && state) status.textContent = source?.dataset?.loadingText || root.dataset.loadingText || '';
    });
  };

  const setError = message => {
    roots().forEach(root => {
      const status = root.querySelector('[data-yurchak-express-status]');
      if (status) status.textContent = message || root.dataset.errorText || '';
    });
  };

  const visibleCount = cart => Array.isArray(cart?.items)
    ? cart.items.reduce((sum, item) => Number(item?.variant_id) === VARIANT_ID ? sum : sum + Number(item?.quantity || 0), 0)
    : Number(cart?.item_count || 0);

  const paintHeaderCount = cart => {
    const count = visibleCount(cart);
    document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble span:first-child')
      .forEach(node => node.textContent = count);
    document.querySelectorAll('.cart-count-bubble').forEach(node => node.classList.toggle('hidden', count === 0));
  };

  const renderDrawer = async cart => {
    if (window.location.pathname.endsWith('/cart')) {
      const current = document.querySelector('[data-ycart-root]');
      const sectionId = current?.dataset?.sectionId;

      if (current && sectionId) {
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', sectionId);
        url.hash = '';

        const response = await fetch(url.toString(), {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        if (response.ok) {
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.getElementById('YurchakCart-' + sectionId);
          if (fresh) {
            current.replaceWith(fresh);
            window.YurchakCartSectionInit?.();
            paintHeaderCount(cart);
            cartCore?.emit?.(cart, 'yurchak-express-delivery', 'section-rendered', { variantId: VARIANT_ID });
            return;
          }
        }
      }

      paintHeaderCount(cart);
      return;
    }

    const response = await fetch(routeRoot() + '?sections=cart-drawer,cart-icon-bubble', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    });
    const sections = await response.json();

    const drawer = document.querySelector('cart-drawer');
    let drawerRendered = false;
    if (drawer && typeof drawer.renderContents === 'function' && sections?.['cart-drawer']) {
      drawer.renderContents({ id: VARIANT_ID, sections });
      drawerRendered = true;
    } else {
      const drawerHtml = sections?.['cart-drawer'];
      if (drawerHtml) {
        const doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
        const next = doc.querySelector('#CartDrawer');
        const current = document.querySelector('#CartDrawer');
        if (next && current) current.innerHTML = next.innerHTML;
      }
    }

    if (!drawerRendered) {
      const bubbleHtml = sections?.['cart-icon-bubble'];
      if (bubbleHtml) {
        const doc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
        const next = doc.querySelector('.shopify-section');
        const current = document.getElementById('cart-icon-bubble');
        if (next && current) current.innerHTML = next.innerHTML;
      }
    }

    paintHeaderCount(cart);
  };

  const announceCart = cart => {
    cartCore?.emit?.(cart, 'yurchak-express-delivery', 'service-toggle', { variantId: VARIANT_ID });
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'yurchak-express-delivery', cartData: cart, variantId: VARIANT_ID });
      }
    } catch (_) {}
  };

  const handleToggle = async event => {
    const input = event.target.closest('[data-yurchak-express-toggle]');
    if (!input || busy) return;
    const root = input.closest('[data-yurchak-express]');
    if (!root || root.dataset.eligible !== 'true') {
      input.checked = root?.dataset?.selected === 'true';
      return;
    }

    busy = true;
    const requested = input.checked;
    setBusy(true, root);

    try {
      const cart = requested ? await addService() : await removeService();
      announceCart(cart);
      await renderDrawer(cart);
    } catch (error) {
      input.checked = !requested;
      setError(root.dataset.errorText || error?.message || '');
    } finally {
      busy = false;
      setBusy(false, root);
    }
  };

  const normalizeStale = async () => {
    if (busy) return;
    const currentRoots = roots();
    if (!currentRoots.length) return;

    const stale = currentRoots.some(root => root.dataset.selected === 'true' && root.dataset.eligible !== 'true');
    const selectedAndEligible = currentRoots.some(root => root.dataset.selected === 'true' && root.dataset.eligible === 'true');
    if (!stale && !selectedAndEligible) return;

    busy = true;
    setBusy(true, currentRoots[0]);
    try {
      if (stale) {
        const cart = await removeService();
        announceCart(cart);
        await renderDrawer(cart);
        return;
      }

      let cart = await fetchCart();
      const items = serviceItems(cart);
      if (!items.length) {
        cart = await addService(cart);
        announceCart(cart);
        await renderDrawer(cart);
        return;
      }

      const updates = {};
      items.forEach((item,index) => {
        const desiredQuantity = index === 0 ? 1 : 0;
        if (Number(item.quantity) !== desiredQuantity) updates[item.key] = desiredQuantity;
      });
      if (Object.keys(updates).length) {
        cart = await cartCore.updateLines(updates, expressAttribute(true));
        announceCart(cart);
        await renderDrawer(cart);
      }
    } catch (error) {
      setError(currentRoots[0]?.dataset?.errorText || error?.message || '');
    } finally {
      busy = false;
      setBusy(false, currentRoots[0]);
    }
  };

  const verifyBeforeCheckout = async currentCart => {
    let cart = currentCart || await fetchCart();
    const items = serviceItems(cart);
    if (!items.length) return cart;

    const response = await fetch(routeRoot() + 'cart', {
      credentials:'same-origin',
      cache:'no-store',
      headers:{Accept:'text/html','X-Requested-With':'XMLHttpRequest'}
    });
    if (!response.ok) throw new Error('Could not verify Express delivery.');

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html,'text/html');
    const snapshot = doc.querySelector('[data-yurchak-express]');
    const eligible = snapshot?.dataset?.eligible === 'true';

    if (!eligible) {
      cart = await removeService(cart);
      announceCart(cart);
      return cart;
    }

    const updates = {};
    items.forEach((item,index) => {
      const desiredQuantity = index === 0 ? 1 : 0;
      if (Number(item.quantity) !== desiredQuantity) updates[item.key] = desiredQuantity;
    });
    if (Object.keys(updates).length) {
      cart = await cartCore.updateLines(updates, expressAttribute(true));
      announceCart(cart);
    }
    return cart;
  };

  window.YurchakExpressDeliveryVerifyCheckout = verifyBeforeCheckout;

  const scheduleNormalize = () => {
    clearTimeout(normalizeTimer);
    normalizeTimer = setTimeout(normalizeStale, 120);
  };

  document.addEventListener('change', handleToggle);
  document.addEventListener('yurchak:cart-updated', scheduleNormalize);

  const observer = new MutationObserver(mutations => {
    if (mutations.some(mutation =>
      Array.from(mutation.addedNodes || []).some(node =>
        node.nodeType === 1 && (node.matches?.('[data-yurchak-express]') || node.querySelector?.('[data-yurchak-express]'))
      )
    )) scheduleNormalize();
  });

  const boot = () => {
    const observerRoot =
      document.querySelector('cart-drawer') ||
      document.querySelector('#CartDrawer') ||
      document.querySelector('main') ||
      document.body;

    observer.observe(observerRoot, { childList: true, subtree: true });
    scheduleNormalize();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
